<div class="card" itemprop="review" itemscope="itemscope" itemtype="http://schema.org/Review">
  <meta itemprop="itemReviewed" content="Book Tickets" />
  <meta itemprop="datePublished" content="{{review.created}}" />
  <div class="card-header">
    <h5 class="card-title" itemprop="author">{{review.name}}</h5>
    <h6 class="card-subtitle mb-2">
      <div itemprop="reviewRating" itemscope="itemscope" itemtype="http://schema.org/Rating">
        <meta itemprop="ratingValue" content="{{review.rating}}" />
        <meta itemprop="worstRating" content="1" />
        <meta itemprop="bestRating" content="5" />
      </div>
      <small>
        <ng-container *ngFor="let rating of [1,2,3,4,5]">
          <i class="fa fa-star yellow" [ngClass]="{'yellow': review.rating >= rating}" aria-hidden="true"></i>
        </ng-container>
      </small>
    </h6>
    <span *ngIf="review.agentSuffix != '#'" class="card-link">Booking Agent: <a [routerLink]="['/our-team', review.agentSuffix]">{{review.bookedBy}}</a></span>
    <span *ngIf="review.agentSuffix == '#'" class="card-link">Booking Agent: {{review.bookedBy}}</span>
  </div>
  <div class="card-body">
    <p class="card-text" itemprop="reviewBody" [innerHtml]="review.reviewText | safeHtml"></p>
  </div>
</div>
